import { motion } from "framer-motion";

/**
 * Iridescent presale progress bar with shimmer and segmented tick marks
 * so progress reads at-a-glance. Empty state still looks intentional
 * (gives the user something to scan even when 0%).
 */
export function ProgressBar({ pct }: { pct: number }) {
  const safe = Math.max(0, Math.min(100, pct));
  return (
    <div className="relative h-3 w-full overflow-hidden rounded-full border border-white/10 bg-white/[0.03]">
      {/* tick marks */}
      <div className="pointer-events-none absolute inset-0 flex">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 border-r border-white/[0.04] last:border-r-0"
          />
        ))}
      </div>
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${safe}%` }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="relative h-full rounded-full"
        style={{
          background:
            "linear-gradient(90deg, #c084fc 0%, #ff2d92 50%, #f5c451 100%)",
          boxShadow:
            "0 0 14px rgba(192, 132, 252, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.4)",
        }}
      >
        <div
          className="absolute inset-0 rounded-full opacity-80"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 2.4s linear infinite",
          }}
        />
      </motion.div>
    </div>
  );
}
